import React, { useEffect, useState, useRef } from 'react'

import './index.scss'

export default function SingerSearcher(props) {

  let { value, search } = props

  const [selfValue, setValue] = useState('')

  const searchRef = useRef(null)

  useEffect(() => {
    value && setValue(value)
    searchRef.current.onsearch = (e) => search(e.target.value)
  }, [value])

  return (<div className="SingerSearcher">
    <form action="" onSubmit={e => e.preventDefault()}>
      <input ref={searchRef} type="search" className="search" value={selfValue} onChange={e => setValue(e.target.value)}></input>
    </form>
    <div className="searchIcon" onClick={() => search(selfValue)}></div>
    {selfValue && <div className="showClose" onClick={() => setValue('')}></div>}
  </div >)
}